class SpecsToggle extends HTMLElement {
  constructor() {
    super();
    this.toggles = this.querySelectorAll('[id^=Toggle-]');
    this.panels = this.querySelectorAll('[id^=Panel-]');
    this.toggles.forEach((el) => el.addEventListener('click', this.handleClick.bind(this)));
  }

  handleClick(e) {
    e.preventDefault();
    this.toggles.forEach((el) => el.removeAttribute('aria-current'));
    this.panels.forEach((el) => el.classList.add('hidden'));
    this.open(e);
  }

  open(e) {
    e.target.setAttribute('aria-current', true);
    this.querySelector(e.target.dataset.toggle).classList.remove('hidden');
  }
}

customElements.define('specs-toggle', SpecsToggle);
